export default __webpack_public_path__ + "assets/Kings_Caslon_Bold.json";